export default () => ({
  serviceRequest: null,
  serviceRequests: [],
  requestHistory: [],
  searchTerm: '',
  pageSize: 10,
  sortDir: 'desc',
  orderBy: 'Id',
  status: '',
  filterBy: 0,
  issues: []
})



// WEBPACK FOOTER //
// ./src/store/modules/servicerequests/state.js